export default "__VITE_ASSET__DF_23hej__"